import { cleanCommonParams } from './common';

const mapCategoryParams = (isCreate, params) => {
    return new Promise((resolve) => {
        resolve({ category: cleanCommonParams(params) });
    });
};

export { mapCategoryParams };
